import React from "react";
import { CustomModal } from "./styles";
import {
  Container,
  Header,
  Title,
  Subtitle,
  Section,
  SectionTitle,
  Table,
} from "./ExhibitLayout";

const numberWithCommas = n =>
  n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

const ModalExhibit4 = ({ machines, goBack }) => (
  <CustomModal goBack={goBack}>
    <Container>
      <Header>
        <Title>Exhibit 4: Production Lines</Title>
        <Subtitle>Cost, capacity, and setup profile for each available production line.</Subtitle>
      </Header>

      <Section>
        <SectionTitle>Production Line Specs</SectionTitle>
        <Table>
          <thead>
            <tr>
              <th>Line</th>
              <th>Cost</th>
              <th>Units / Hour</th>
              <th>Useful Life</th>
              <th>Annual Capacity</th>
              <th>Setup Time</th>
              <th>Ideal Utilization</th>
            </tr>
          </thead>
          <tbody>
            {machines.map(machine => (
              <tr key={machine.id}>
                <td><b>{machine.id}</b></td>
                <td className="numeric">${numberWithCommas(machine.costs)}</td>
                <td className="numeric">{machine.units_per_hour}</td>
                <td className="numeric">{machine.lifetime_years} years</td>
                <td className="numeric">{numberWithCommas(machine.annual_hours)} hours</td>
                <td className="numeric">{machine.setup_time} months</td>
                <td className="numeric">75%</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Section>
    </Container>
  </CustomModal>
);

export default ModalExhibit4;



// WEBPACK FOOTER //
// ./src/components/bcase/ModalExhibit4.js